import { Action } from '@ngrx/store';

export enum NavActionTypes {
  ShowMenu = '[Nav] Show Menu',
  HideMenu = '[Nav] Hide Menu',
  OpenSideNav = '[Nav] Open Side Nav',
  CloseSideNav = '[Nav] Close Side Nav',
  Navigation = '[Nav] Navigation',
  SideNavNavigation = '[Nav] Side Nav Navigation',
  MoveHome = '[Nav] Move Home'
}

export class ShowMenu implements Action {
  readonly type = NavActionTypes.ShowMenu;
}

export class HideMenu implements Action {
  readonly type = NavActionTypes.HideMenu;
}

export class OpenSideNav implements Action {
  readonly type = NavActionTypes.OpenSideNav;
}

export class CloseSideNav implements Action {
  readonly type = NavActionTypes.CloseSideNav;
}

export class Navigation implements Action {
  readonly type = NavActionTypes.Navigation;

  constructor(public payload: {url: string}) {}
}

export class SideNavNavigation implements Action {
  readonly type = NavActionTypes.SideNavNavigation;

  constructor(public payload: {url: string}) {}
}

export class MoveHome implements Action {
  readonly type = NavActionTypes.MoveHome;
}


export type NavActions =
  | ShowMenu
  | HideMenu
  | OpenSideNav
  | CloseSideNav
  | Navigation
  | SideNavNavigation
  | MoveHome;
